import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';
import update from 'immutability-helper';

//helpers:
import { getData, postData } from '../../dataLib';

//actions:
import { openDialog, hideDialog, setSaveState } from '../../actions/index';

//components:
import NeuriteGrid from '../../components/neurite_grid';

//material ui components:
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Paper from '@material-ui/core/Paper';



//grid de datos de facturas de MKT
//solo trabaja con state local ya que ningun otro control depende de estos datos
//y hace todas las modificaciones directamente en la DB cuando se hace click en OK

const styles = theme => ({
    input: {
        width: 80,
        height: 35,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
    },
    button: {
        margin: '15px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    buttonNew: {
        margin: '15px auto',
        padding: '10px 4%',
        borderRadius: 0,
        width: 120,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    bottomBtn: {
        display: 'flex'
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    divData: {
        position: 'relative',
        display: 'flex'
    },
    root: {
        display: 'block'
    },
    formControl: {
        margin: theme.spacing(1),
    },
    paperNew: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        backgroundColor: '#eeeeee',
        display: 'flex',
        flexDirection: 'column',
        width: 340
    },
    divGrid: {
        width: 560
    },
    labelCheck:{
        marginLeft: 0
    }

});

class CentroMailing extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            rows: [],
            cierreDiario: true,
            cierreSemanal: true,
            inventario: false,
            showSpinner: true,
        };
    };

    componentDidMount = () => {
        this.getMailings();
    }

    // componentDidUpdate(prevProps) {
    //     if (this.producto === undefined &&
    //         prevProps.centroDiaSelected !== this.props.centroDiaSelected) {
    //         this.getMkt();
    //         this.props.getArtMktCentro(this.props.centroDiaSelected.centro.id);
    //     }

    //     if (prevProps.centroDiaSelected.dia !== this.props.centroDiaSelected.dia || prevProps.centroDiaSelected.centro !== this.props.centroDiaSelected.centro)
    //         this.setState({ ...this.state, showSpinner: true })
    // };

    messageError = error => {

        this.props.openDialog('SimpleMessage', {
            message: error
        }, uuidv4(), false, 'sm');

    };


    deleteMailing = (mailing) => {
        let rows = this.state.rows.filter(m => m.id !== mailing.id);
        this.setState({ ...this.state, rows: rows });
    };


    //obtiene las facturas de MKT
    getMailings = () => {

        let mailingsURL = 'CentroMailings?centro_id=' + this.props.centroId;

        getData(mailingsURL,
            (response) => {
                this.setState({ ...this.state, rows: response.data, showSpinner: false })
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR obteniendo mailings'
                }, uuidv4(), false, 'sm');
            },
            this.props.user
        );
    };
   
    updateMailings = () => {

        var mailings = this.state.rows.slice();
        mailings.forEach((m) => {
            if (typeof m.id !== 'number') m.id = -1;
        });

        let mailingsURL = 'CentroMailings/mailings?centroId=' + this.props.centroId;


        postData(mailingsURL,
            () => {
                this.props.hideDialog();
                this.props.openDialog('SimpleMessage', {
                    message: 'lista de mailing actualizados'
                }, uuidv4(), false, 'sm');
                this.props.setSaveState(false);
            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR actualizando lista de mailings'
                }, uuidv4(), false, 'sm');
            },
            mailings,
            this.props.user
        );


    };

    handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {

        var rows = this.state.rows.slice();

        for (let i = fromRow; i <= toRow; i++) {
            let updatedRow = update(this.state.rows[i], { $merge: updated });
            rows[i] = updatedRow;
        }

        this.props.setSaveState(true);
        this.setState({ ...this.state, rows: rows });

    };

    handleGridNewRow = () => {

        const mailing = {
            id: uuidv4(),
            centroId: this.props.centroId,
            mail: this.state.email,
            bCierreDiario: this.state.cierreDiario,
            bCierreSemanal: this.state.cierreSemanal,
            bInventario: this.state.inventario,
        }


        let rows = this.state.rows.slice();
        rows.push(mailing);
        this.props.setSaveState(true);
        this.setState({ ...this.state, rows: rows, email: '', bCierreDiario: true, bCierreSemanal: true, bInventario: false });

    }

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    }

    handleCheckboxChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.checked });
    };

    render() {
        const { classes } = this.props;

        if (this.state.showSpinner)
            return (
                <div className={classes.spinnerContainer}>
                    <CircularProgress className={classes.spinner} color="primary" />
                </div>
            );

        return (
            <div className={classes.root}>
                <div className={classes.divData}>

                    <div className={classes.divGrid}>
                        <NeuriteGrid
                            id="c_m"
                            columns={[
                                { key: 'mail', name: 'Email', editable: true, dragable: false, width: 260 },
                                { key: 'bCierreDiario', name: 'Cierre Diario', editable: true, dragable: false, type: 'bool', width: 110 },
                                { key: 'bCierreSemanal', name: 'Cierre Semanal', editable: true, dragable: false, type: 'bool', width: 110 },
                                //{ key: 'bInventario', name: 'Inventario', editable: true, dragable: false, type: 'bool', width: 70 }
                            ]}
                            rows={this.state.rows}
                            height={300}
                            buttonEdit={false}
                            buttonDelete={true}
                            buttonNew={false}
                            onRowsUpdated={this.handleGridRowsUpdated}
                            onDeleteClick={this.deleteMailing}
                        />
                    </div>

                    <Paper className={classes.paperNew}>
                        <FormControl className={classes.formControl} >
                            <TextField
                                id={'email'}
                                label={'Email'}
                                margin="normal"
                                value={this.state.email}
                                onChange={(event) => this.handleValueChange(event, 'email')}
                            />
                        </FormControl>

                        <FormControl className={classes.formControl}>
                            <FormControlLabel className={classes.labelCheck}
                                control={
                                    <Checkbox
                                        checked={this.state.cierreDiario}
                                        onChange={event => this.handleCheckboxChange(event, 'cierreDiario')}
                                        color="primary"
                                    />
                                }
                                label={'Cierre diario'}
                            />
                        </FormControl>
                        <FormControl className={classes.formControl}>
                            <FormControlLabel className={classes.labelCheck}
                                control={
                                    <Checkbox
                                        checked={this.state.cierreSemanal}
                                        onChange={event => this.handleCheckboxChange(event, 'cierreSemanal')}
                                        color="primary"
                                    />
                                }
                                label={'Cierre semanal'}
                            />
                        </FormControl>
                        <FormControl hidden className={classes.formControl}>
                            <FormControlLabel className={classes.labelCheck}
                                control={
                                    <Checkbox
                                        checked={this.state.inventario}
                                        onChange={event => this.handleCheckboxChange(event, 'inventario')}
                                        color="primary"
                                    />
                                }
                                label={'Inventario'}
                            />
                        </FormControl>

                        <Button variant="contained" color="primary" className={classes.buttonNew} onClick={() => { this.handleGridNewRow() }}>Nuevo</Button>
                    </Paper>
                </div>

                <div className={classes.bottomBtn}>
                    <Button variant="contained" color="secondary" className={classes.button} onClick={() => { this.props.hideDialog() }}>Cerrar</Button>
                    <Button variant="contained" color="primary" className={classes.button} onClick={() => { this.updateMailings() }}>Guardar</Button>
                </div>

            </div>
        );
    };
};


CentroMailing.propTypes = {
    //state
    user: PropTypes.object,

    //dispatch
    hideDialog: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,

    //parametros:
    centroId: PropTypes.number.isRequired

};

function mapStateToProps(state) {
    return {
        user: state.oidc.user
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        hideDialog,
        openDialog,
        setSaveState
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(CentroMailing));